import React from "react";
import { Modal, Button, Typography } from "antd";

const { Text } = Typography;

interface RemoveSocietiesConfirmModalProps {
  open: boolean;
  status: string;
  count: number;
  onCancel: () => void;
  onConfirm: () => void;
}

export const RemoveSocietiesConfirmModal: React.FC<RemoveSocietiesConfirmModalProps> = ({
  open,
  status,
  count,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal
      title={null}
      open={open}
      onCancel={onCancel}
      width={420}
      centered
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
          <Button onClick={onCancel} disabled={status === "saving"}>
            Cancel
          </Button>
          <Button type="primary" danger onClick={onConfirm} loading={status === "saving"}>
            Remove
          </Button>
        </div>
      }
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Text style={{ fontSize: "14px", color: "#262626", display: "block" }}>
          Are you sure you want to remove {count} selected {count === 1 ? "society" : "societies"} from
          this drop point?
        </Text>
      </div>
    </Modal>
  );
};
